import React from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import Login from '../src/components/views/Login';
import PainelModulos from '../src/components/views/PainelModulos';
import SelecionarFilial from '../src/components/views/SelecionarFilial';
import PrivateRoute from '../src/components/elements/PrivateRoute';
import PublicRoute from '../src/components/elements/PublicRoute';
import { BASE_URL } from './services/api';

const Router = () => (
    <BrowserRouter basename={BASE_URL}>
        <Switch>
            <PublicRoute restricted={false} path="/login" component={Login}/>
            <PrivateRoute restricted={true} path="/selecionar-filial" component={SelecionarFilial}/>
            <PrivateRoute restricted={true} path="/painel-modulos" component={PainelModulos}/>
            <PublicRoute restricted={false} path="/" component={Login}/>
        </Switch>
    </BrowserRouter>
);

export default Router;
